import Vue from 'vue';
import { configure } from 'vee-validate';
import VueI18n from 'vue-i18n';
import en from '@/core/locales/en.json';
// import de from '@/core/locales/de.json';
// import es from '@/core/locales/es.json';
// import fr from '@/core/locales/fr.json';
// import hi from '@/core/locales/hi.json';
// import it from '@/core/locales/it.json';
// import ja from '@/core/locales/ja.json';
// import nl from '@/core/locales/nl.json';
// import pt from '@/core/locales/pt.json';
// import ru from '@/core/locales/ru.json';
// import zh from '@/core/locales/zh.json';

import enVee from 'vee-validate/dist/locale/en.json';
// import frVee from 'vee-validate/dist/locale/fr.json';
// import itVee from 'vee-validate/dist/locale/it.json';
// import jaVee from 'vee-validate/dist/locale/ja.json';
// import nlVee from 'vee-validate/dist/locale/nl.json';
// import ptVee from 'vee-validate/dist/locale/pt_PT.json';
// import ruVee from 'vee-validate/dist/locale/ru.json';
// import zhVee from 'vee-validate/dist/locale/zh_CN.json';

Vue.use(VueI18n);

en['validation'] = enVee.messages;
// fr.validation = frVee.messages;
// it.validation = itVee.messages;
// ja.validation = jaVee.messages;
// nl.validation = nlVee.messages;
// pt.validation = ptVee.messages;
// ru.validation = ruVee.messages;
// zh.validation = zhVee.messages;

const vueI18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: en,
    // de: de,
    // es: es,
    // fr: fr,
    // hi: hi,
    // it: it,
    // ja: ja,
    // nl: nl,
    // pt: pt,
    // ru: ru,
    // zh: zh,
  },
});

configure({
  // this will be used to generate messages.
  defaultMessage: (field, values) => {
    values._field_ = vueI18n.t(`${field}`);
    return vueI18n.t(`validation.${values._rule_}`, values).toString();
    // toString needed because *sometimes* translation can return a non-string
  },
});

export default vueI18n;
